import { useConfigService } from '@thd-nucleus/experience-context';
import { formatBundles } from '../utils/product-bundle-utils';

export const useGetBundleConfigSwitch = () => {
  const configBundleProducts = formatBundles(useConfigService('bundleProducts') || null);
  const configSelectableVariantProducts = formatBundles(useConfigService('selectableVariantProducts') || null);
  const configExperienceType = useConfigService('bundleExperience') || null;
  const configBundleType = useConfigService('bundleType') || null;
  const configBundleProductsDetails = useConfigService('bundleProductsDetails') || null;
  const enableAccessories = useConfigService('fs:isAccessoriesFeatureEnabled') || null;
  const enableRemoveItemPromoImage = useConfigService('fs:isRemoveItemPromoImageEnabled') || null;

  return {
    configBundleProducts,
    configSelectableVariantProducts,
    configExperienceType,
    configBundleType,
    configBundleProductsDetails,
    enableAccessories,
    enableRemoveItemPromoImage
  } || {};

};